import { render, staticRenderFns } from "./pos-VatReport.vue?vue&type=template&id=db48be6c"
import script from "./pos-VatReport.vue?vue&type=script&lang=js"
export * from "./pos-VatReport.vue?vue&type=script&lang=js"
import style0 from "./pos-VatReport.vue?vue&type=style&index=0&id=db48be6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports